exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".resources[data-v-9a8d0336]{position:absolute;top:50px;left:0;background:#e6e7e8;min-width:250px;z-index:999}.resources a[data-v-9a8d0336]{display:block;color:hsla(225,2%,47%,.6);border-bottom:2px solid hsla(225,2%,47%,.2);text-decoration:none;padding-bottom:4px;font-size:1.25rem;padding:12px 15px 7px;text-transform:uppercase;transition:all .3s}.resources a[data-v-9a8d0336]:last-child{border-bottom:0 solid hsla(225,2%,47%,.6);margin-bottom:0}.resources a[data-v-9a8d0336]:hover{background:#000;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-9a8d0336","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Resources.vue
// module id = 90
// module chunks = 0